import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_5 = { class: "rounded-lg border bg-gray-50 p-4" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex gap-1 pl-1" }
const _hoisted_8 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm text-gray-600"
}

import { computed, onMounted } from 'vue';

import { useRulesStore } from '@/store/rules';
import { useEstimatedSegments } from '@/composables/useEstimatedSegments';
import type { RuleOptionItem } from '@/utils/types';

interface Props {
  item: RuleOptionItem;
  modelValue?: number | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ItemRuleInput',
  props: {
    item: {},
    modelValue: {}
  },
  setup(__props: any) {

const props = __props;

const { getRuleById, fetch } = useRulesStore();
const { segmentRules } = useEstimatedSegments({
  visibility: 'all'
});

const rule = computed(() => {
  return getRuleById(props.item.rule_id);
});

const ruleEvaluation = computed(() => {
  if (!rule.value || !segmentRules.value) return null;

  for (const segment of segmentRules.value) {
    const segmentRule = segment.rules.find((r) => r.id === rule.value?.id);
    if (segmentRule) {
      return {
        eval: segmentRule.eval,
        expression: segmentRule.expression,
      };
    }

    for (const group of segment.groups) {
      const groupRule = group.rules.find((r) => r.id === rule.value?.id);
      if (groupRule) {
        return {
          eval: groupRule.eval,
          expression: groupRule.expression,
        };
      }
    }
  }

  return null;
});

const displayValue = computed(() => {
  if (!ruleEvaluation.value) return 'Brak danych';

  return ruleEvaluation.value.eval;
});

onMounted(async () => {
  await fetch();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.item.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(displayValue.value), 1),
          (rule.value?.unit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(rule.value.unit), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})